
require(["js/core/fusion-web-framework"]);
